export default "__VITE_ASSET__DW9DCw17__"